/**
 * API Configuration Constants
 *
 * Dynamically selects the backend API URL based on
 * the current frontend hostname.
 */

/**
 * Current frontend hostname extracted from browser location.
 *
 * Examples:
 * localhost
 * cilantro3-dev-frontend-....azurewebsites.net
 * cilantrouat.mycompass.co.in
 * cilantro.mycompass.co.in
 */
const currentHost = window.location.hostname;


/**
 * ---------------------------------------------------------
 * Frontend Hostname -> Backend API URL
 * ---------------------------------------------------------
 */
const backendUriMap: Record<string, string> = {

  // LOCAL
  localhost:
    "https://cilantro3-dev-backend-c9b4bhh9hdbxb2dn.centralindia-01.azurewebsites.net",
 
  // DEV
  "cilantro3-dev-frontend-bvhwc9hvavhsa6cs.centralindia-01.azurewebsites.net":
    "https://cilantro3-dev-backend-c9b4bhh9hdbxb2dn.centralindia-01.azurewebsites.net",

  // UAT - Custom Domain
  "cilantrouat.mycompass.co.in":
    "https://cilantrouat-appservices-backend.azurewebsites.net",

  // UAT - Azure App Service Domain
  "cilantrouat-cr-appservices-frontend-ajccekcedzefevfq.centralindia-01.azurewebsites.net":
    "https://cilantrouat-cr-appservices-backend-chc0drewdgcdbad2.centralindia-01.azurewebsites.net",

  // PROD
  "cilantro.mycompass.co.in":
    "https://cilantro-appservices-backend-prd-g4dzftgyazdpg9cx.centralindia-01.azurewebsites.net",
};


/**
 * ---------------------------------------------------------
 * CI/CD Environment Variable
 * ---------------------------------------------------------
 *
 * GitHub Actions can provide:
 *
 * REACT_APP_AZURE_APP_BASE_URL
 *
 * If supplied, this takes priority over hostname mapping.
 */
const envBaseUrl = (process.env.REACT_APP_AZURE_APP_BASE_URL || "").trim();


/**
 * ---------------------------------------------------------
 * Hostname Based Backend URL
 * ---------------------------------------------------------
 */
const mappedBaseUrl =
  Object.entries(backendUriMap).find(
    ([host]) =>
      currentHost === host ||
      currentHost.includes(host)
  )?.[1] || "";


/**
 * ---------------------------------------------------------
 * Final Backend URL
 * ---------------------------------------------------------
 *
 * Priority:
 *
 * 1. CI/CD environment variable
 * 2. Frontend hostname mapping
 * 3. No URL -> throw error
 */
export const BASE_URL =
  envBaseUrl || mappedBaseUrl;


if (!BASE_URL) {
  throw new Error(
    `No backend API configuration found for frontend hostname "${currentHost}".`
  );
}


/**
 * ---------------------------------------------------------
 * External API
 * ---------------------------------------------------------
 */
export const JSON_PLACEHOLDER_URL =
  "https://jsonplaceholder.typicode.com";


/**
 * ---------------------------------------------------------
 * Current User ID
 * ---------------------------------------------------------
 */
export const USERID =
  localStorage.getItem("userid") || 1;


/**
 * ---------------------------------------------------------
 * API Request Timeout
 * ---------------------------------------------------------
 */
export const TIMEOUT = 10000;